<template>
  <LayoutHeader class="l-header">
    <div class="logo">
      <img :src="logo" alt="J&T" />
      <div class="name ml-8">{{ title }}</div>
    </div>
    <div class="l-header-right">
      <LangSelect :reload="true"></LangSelect>
      <span class="iconfont icon-xiazai xiazai mr-24 ml-24" @click="$router.push('/downloadCenter')"></span>
      <Dropdown class="user">
        <span class="flex">
          <Avatar>
            <template #icon>
              <img src="@jms/assets/images/header_icon.png" alt="" />
            </template> </Avatar
          >&nbsp;
          <span>{{ $lang('欢迎你') }}，{{ authStoreState.userInfo.userName }}</span>
          <span class="iconfont icon-shouqi ml-6"></span>
        </span>
        <template #overlay>
          <Menu class="mt-0">
            <!-- <MenuItem><SwapOutlined />&nbsp; {{ $lang('语言切换') }} <LangSelect :reload="true"></LangSelect></MenuItem> -->
            <MenuItem v-if="isDev" @click="translateCollectorVisible = true">
              <Badge :count="untranslatedCount" :offset="[10, 0]">
                <span>未翻译字段收集</span>
              </Badge>
            </MenuItem>
            <MenuItem @click="loginOut"> <LogoutOutlined />&nbsp; {{ $lang('退出登录') }}</MenuItem>
          </Menu>
        </template>
      </Dropdown>
    </div>
  </LayoutHeader>
  <TranslateCollector v-if="isDev" v-model:visible="translateCollectorVisible" />
</template>

<script lang="ts" setup>
  import { reactive, ref, computed } from 'vue'
  import { LayoutHeader, Dropdown, Avatar, Menu, MenuItem, Input, Badge, Modal, Button } from 'ant-design-vue'
  import { storeToRefs } from 'pinia'
  import { LogoutOutlined, SwapOutlined } from '@ant-design/icons-vue'
  import { useAuthStore } from '@jms/store/auth'
  // import { UrlEnum, UnionEnum } from '@jms/utils/enums/Route'
  import { lang, reLogin } from '@jms/utils'
  // import { useModal } from '@xinghai/site-common'
  import { useRouter, useRoute } from 'vue-router'
  // import { LangConst } from '@jms/utils/enums'
  // const [router, route] = [useRouter(), useRoute()]
  import { translateCollector } from '@jms/utils/translateCollector'
  import TranslateCollector from './components/TranslateCollector.vue'

  const authStore = useAuthStore()
  const isDev = import.meta.env.NODE_ENV!=='production'
  const translateCollectorVisible = ref(false)
  const untranslatedCount = computed(() => translateCollector.getUntranslatedCount())

  defineProps({
    logo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  })

  const authStoreState = reactive({
    ...storeToRefs(authStore)
  })
  const loginOut = () => {
    Modal.confirm({
      title: lang('提示'),
      centered: true,
      content: lang('确定退出当前账号？'),
      onOk: () => {
        authStore.logOut().then((res: any) => {
          if (res.code === 1) {
            localStorage.removeItem('userCode')
            reLogin()
          }
        })
      }
    })
  }
  // const showNotice = () => {
  //   if (unReadTotal.value === 0) return
  //   noticeFlag.value = !noticeFlag.value
  // }
  /**未读消息 */
  const unReadTotal = ref(0)
</script>

<style lang="less" scoped>
  .l-header {
    padding: 0 20px 0 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;

    .logo {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 248px;

      img {
        height: 40px;
      }

      .name {
        width: 200px;
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
      }
    }

    &-right {
      margin-left: auto;
      .flex;

      .input {
        border-radius: 16px;
        width: 220px;
        color: #b7b7b7;
      }
    }

    .user {
      cursor: pointer;
    }

    .collapsed {
      font-size: 20px;
      cursor: pointer;
    }

    .xiazai,
    .xiaoxi {
      font-size: 32px;
      .pointer;
    }

    .icon-shouqi {
      font-size: 12px;
      transform: scale(0.5);
    }
  }

  .imgs {
    text-align: center;

    > img {
      width: 300px;
      height: 300px;
    }
  }

  .text {
    text-align: center;
    color: @text-color1;
  }
</style>
